import { connect } from 'speedux';
import { FileTextOutlined } from '@ant-design/icons';
import { Card, Select, Spin, Timeline } from 'antd';
import React, { useEffect, useState } from 'react';

import {
  ContainerStyle,
  HeaderContainerStyle,
  LogDateStyle,
  TextStyle,
} from './styles';
import { eventsMapper, eventTypes } from './helpers';
import Module from './module';

const { Option } = Select;

const History = ({
  campaignId,
  campaignName,
  state: { historyLogs, workflowRuns, getLogsLoading, getWorkflowRunsLoading },
  actions: { getCampaignLogs, getCampaignWorkflowRuns },
}) => {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState([]);

  useEffect(() => {
    getCampaignLogs(campaignId, filter);
    getCampaignWorkflowRuns(campaignId);
  }, [campaignId, filter, getCampaignLogs, getCampaignWorkflowRuns]);

  useEffect(() => {
    setLogs(eventsMapper({ historyLogs, workflowRuns, filter }));
  }, [filter, historyLogs, workflowRuns]);

  const loading = getLogsLoading || getWorkflowRunsLoading;

  return (
    <ContainerStyle>
      <HeaderContainerStyle>
        <h3>
          <span data-test="campaignName">{campaignName}</span>'s History
        </h3>
        <Select
          labelInValue
          mode="multiple"
          value={filter}
          onChange={item => setFilter(item)}
          style={{ minWidth: '25rem' }}
          placeholder="Type to filter..."
        >
          {eventTypes.map(typeKey => (
            <Option
              value={typeKey}
              key={typeKey}
              style={{ textTransform: 'capitalize' }}
            >
              {typeKey?.replace(/_/g, ' ')?.toLowerCase()}
            </Option>
          ))}
        </Select>
      </HeaderContainerStyle>

      <Spin spinning={loading} size="large">
        <Card
          title="Logs Timeline"
          size="small"
          style={{ marginTop: '2rem' }}
          bodyStyle={{ padding: '0.5rem' }}
        >
          <Timeline mode="left">
            {logs.map(log => (
              <Timeline.Item
                key={log.id}
                label={<LogDateStyle>{log.date}</LogDateStyle>}
                dot={log.icon}
                color={log.color}
              >
                <b style={{ textTransform: 'capitalize' }}>
                  {log.title}{' '}
                  <TextStyle>
                    {log.author ? `| by: ${log.author} ` : ''}
                  </TextStyle>
                </b>
              </Timeline.Item>
            ))}

            {!logs.length && !loading && (
              <h3 style={{ textAlign: 'center' }}>
                <b>
                  No logs <FileTextOutlined />
                </b>
              </h3>
            )}
          </Timeline>
        </Card>
      </Spin>
    </ContainerStyle>
  );
};

export default connect(History, Module);
